import type { IUserConfig } from '@api/types';

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface IAuth {
  token: string;
  userConfig: IUserConfig;
}

const initialState: IAuth = {
  token: '',
  userConfig: {
    brands: [],
    userId: '',
    userType: '',
    username: '',
    permissions: [],
  },
};

const authSlice = createSlice({
  initialState,
  name: 'auth',
  reducers: {
    setToken: (state: IAuth, action: PayloadAction<IAuth['token']>) => {
      state.token = action.payload;
    },
    logOut: (state) => {
      state.token = initialState.token;
      state.userConfig = initialState.userConfig;
    },
    setUserConfig: (
      state: IAuth,
      action: PayloadAction<IAuth['userConfig']>
    ) => {
      state.userConfig = action.payload;
    },
  },
});

export const { logOut, setToken, setUserConfig } = authSlice.actions;

export default authSlice.reducer;
